import React from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Button,
  ParagraphText,
  Card,
  StackItem,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { COB_LIBRARY_ASSET_KEYS } from '../../types/cob-library.types';
import COBQuestioner from '../../assets/json/COB_QUESTIONER.json';
import useCobStore from '../../store/cob-store';

export function SuccessModal() {
  const rockStarContent = COBQuestioner.COB.ROCKSTAR.CONTENT.replace(
    '24 hours',
    '<strong style="font-weight: bold">24 hours</strong>',
  );
  const isBelow400 = useMediaQuery(queryHelpers.down(400));
  const navigate = useNavigate();
  const resetInitialState = useCobStore((state: any) => state.resetState);
  const saveCobInformation = useCobStore((state: any) => state.saveCOBInfo);
  const initialStateInfo = useCobStore((state: any) => state.initialCOB);
  const profileInfo = useCobStore((state: any) => state.demographics);
  const demographicInfo = useCobStore(
    (state: any) => state.saveDemographicsInfo,
  );

  const historyClose = () => {
    localStorage.clear();
    resetInitialState();
    saveCobInformation(initialStateInfo);
    demographicInfo(profileInfo);
    navigate(-1);
  };

  return (
    <>
      <StackLayout
        data-testid="success_modal"
        horizontalAlignment="center"
        css={
          {
            backgroundColor: 'White',
            maxWidth: '480px',
            '@mobile': { height: '800px' },
            '@desktop': { height: '830px', width: '480px' },
            '@laptop': { height: '800px' },
            '@mobileLandscape': { height: '800px' },
            '@tablet': { height: '800px' },
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#FFFFFF',
              padding: '74px 32px 0px 32px',
              marginTop: '-80px',
              height: '842px',
              minHeight: '910px',
              background: '#FFFFFF',
            } as GDSStyleObject
          }
        >
          <Card.Flat
            css={{
              maxWidth: '480px',
              minHeight: '500px',
              border: '0px solid',
              '@mobile': {
                paddingLeft: isBelow400 ? '0px' : '10px',
                paddingRight: isBelow400 ? '0px' : '10px',
                width: isBelow400 ? '390px' : '452px',
              },
              '@desktop': { width: '480px' },
              '@laptop': { width: '480px' },
              '@mobileLandscape': { width: '480px' },
              '@tablet': { width: '480px' },
            }}
          >
            <Card.Image
              image={useStaticAsset(COB_LIBRARY_ASSET_KEYS.ROCK_STAR) as string}
              imageAlt="COB header"
            />
            <Box
              css={
                {
                  marginBottom: '10px',
                  paddingLeft: '18px',
                  paddingRight: '32px',
                  textAlign: 'justify',
                } as GDSStyleObject
              }
            >
              <HeadingText
                size="md"
                level="4"
                css={
                  {
                    fontSize: '$headingOne',
                    padding: '$quarter $none $quarter $quarter',
                    justifyContent: 'left',
                  } as GDSStyleObject
                }
              >
                {COBQuestioner.COB.ROCKSTAR.TITLE}
              </HeadingText>
            </Box>
            <Box
              css={{
                paddingLeft: '20px',
                paddingRight: '20px',
                marginTop: '20px',
                '@mobile': {
                  justifyContent: 'center',
                },
              }}
            >
              <ParagraphText
                css={{
                  size: 'md',
                  padding: '$quarter $quarter $quarter $quarter',
                }}
              >
                {/* {COBQuestioner.COB.ROCKSTAR.CONTENT} */}
                {rockStarContent}
              </ParagraphText>
              <ParagraphText
                css={{
                  size: 'md',
                  padding: '$quarter $quarter $quarter $quarter',
                }}
              >
                {COBQuestioner.COB.ROCKSTAR.SUBSONTENT}
              </ParagraphText>
            </Box>
          </Card.Flat>
        </Box>
      </StackLayout>

      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'row',
            padding: '$quarter',
            width: '480px',
            justifyContent: 'space-between',
            marginTop: '$oneAndHalf',
          } as GDSStyleObject
        }
      >
        <StackItem
          css={
            {
              padding: '$none $none',
            } as GDSStyleObject
          }
        >
          {/* <UtilityText>
            {pageCount} of {pageCount}
          </UtilityText> */}
        </StackItem>
        <StackItem
          css={
            {
              textAlign: 'right',
            } as GDSStyleObject
          }
        >
          <Button
            data-testid="historyClose"
            onClick={historyClose}
            size="small"
            css={{
              color: '#FFFFFF',
              cursor: 'pointer',
              backgroundColor: '$interactiveActionPrimary',
              textAlign: 'center',
              justifyContent: 'center',
              lineHeight: '55px',
              margin: '20px 5px 30px 50px',
              '@mobile': {
                margin: '40px 40px 30px 10px',
                position: isBelow400 ? 'relative' : '',
                right: isBelow400 ? '25px' : '',
              },
              height: '48px',
              width: '138px',
              fontSize: '$bodyOne',
              fontWeight: '$semibold',
            }}
          >
            <Box css={{ paddingLeft: '0px' }}>
              {COBQuestioner.COB.Buttons.DONE}
            </Box>
          </Button>
        </StackItem>
      </Box>
    </>
  );
}
